import { Path } from "react-native-svg";
import CustomIcon, { CustomIconProps } from "./CustomIcon";

const Parking: React.FC<CustomIconProps> = (props) => (
  <CustomIcon {...props}>
    <Path clipRule="evenodd" d="M9 12H10.5C12.433 12 14 10.433 14 8.5C14 6.567 12.433 5 10.5 5H7V15H9V12ZM2 1H18C18.5523 1 19 1.44772 19 2V18C19 18.5523 18.5523 19 18 19H2C1.44772 19 1 18.5523 1 18V2C1 1.44772 1.44772 1 2 1ZM9 7H10.5C11.3284 7 12 7.67157 12 8.5C12 9.3284 11.3284 10 10.5 10H9V7Z" fillRule="evenodd" /> 
  </CustomIcon>
);

export default Parking;